import { ReactNode } from 'react'

export type SchedulingLayoutShadcnComponentProps = {
  children: ReactNode
}

export function SchedulingLayoutShadcnComponent({ children }: SchedulingLayoutShadcnComponentProps) {
  return <>{children}</>
}
